/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useCampusData, useCampusFeatureFlags } from '../context/CampusContextProvider';

import MeterCardContainer from '../components/MeterCardContainer';
import KioskModel from '../components/KioskModel';
import EnergyUtilityMeterDetail from './subsections/EnergyUtilityMeterDetail';
import { setCurrentGX } from '../actions';
import { connect } from 'react-redux';
import WithRouter from '../utilities/WithRouter';

import EnergyIcon from '../components/icons/EnergyIcon';

import './Energy.scss';

require('highcharts/modules/accessibility');
require('highcharts/modules/draggable-points');
require('highcharts/modules/exporting');
require('highcharts/modules/export-data');

const Energy = ({
  currentBuildingId,
  currentGXId,
  // hasSingleGX,
  currentGXData,
  onBuildingChange,
  onGXChange,
  onZoneChange,
  updateGXData,
  showMobile,
  activePage,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const campusData = useCampusData();
  const campusFeatureFlags = useCampusFeatureFlags();
  const currentCampusData = campusData.data;
  const hasSingleGX = campusFeatureFlags.hasSingleGX;

  // useEffect(() => {
  //   console.log('Energy currentCampusData', currentCampusData);
  // }, [currentCampusData]);

  let currentSelectedMeterData;
  const gxParam = params.gxId;
  const currentCampusId = params.campusId;

  useEffect(() => {
    replaceUrl();
  }, [updateGXData]);

  //Call energy API when campus change
  useEffect(() => {
    updateGXData();
  }, [currentCampusId]);

  //When gx data updates, clear graphs and reload
  useEffect(() => {
    if (
      currentGXData?.gridInterconnects?.length === 1 &&
      currentGXId !==
        currentGXData.gridInterconnects[0].gridInterconnectDescription.gridInterconnectEntityKey
    ) {
      onGXChange(
        currentGXData.gridInterconnects[0].gridInterconnectDescription.gridInterconnectEntityKey
      );
    }

    //Graph data update every 5 seconds
    let interval = setInterval(() => {
      updateGXData();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentGXData]);

  function replaceUrl() {
    if (hasSingleGX && (gxParam === undefined || gxParam !== currentGXId) && currentGXId !== null) {
      // TODO: FIX URL REPLACEMENT LOGIC
      // Breaks if remove currentGXId from parent
      // console.log('replaceUrl');
      // console.log('currentCampusDataLoading', currentCampusDataLoading);
      // console.log('gxParam', gxParam);
      // console.log('currentGXId', currentGXId);
      // console.log('hasSingleGX', hasSingleGX);
      // if (
      //   !currentCampusDataLoading &&
      //   hasSingleGX &&
      //   (gxParam === undefined || gxParam !== currentGXId) &&
      //   currentGXId !== null
      // ) {
      navigate('/energy/' + currentCampusId + '/' + currentGXId, { replace: true });
    }
  }

  const navigateWithValidation = (newPath) => {
    if (location.pathname !== newPath) {
      navigate(newPath);
    }
  };

  const handleMeterSelect = (selectedMeter) => {
    onGXChange(selectedMeter);
    navigateWithValidation('/energy/' + currentCampusId + '/' + selectedMeter);
  };

  return (
    <section className={showMobile ? 'energy-section mobile' : 'energy-section desktop'}>
      {currentCampusData && currentGXData && (!currentGXId || hasSingleGX) ? (
        <>
          <div className={showMobile ? 'header-container mobile' : 'header-container'}>
            <div className="header">
              <EnergyIcon
                backgroundFill={'none'}
                fillColor={'#02222B'}
                strokeColor={'#02222B'}
                strokeWidth={2}
                width="18px"
              />
              <h1>Energy</h1>
            </div>
          </div>

          {currentGXData.gridInterconnects ? (
            <>
              {currentGXData.gridInterconnects?.map((gx) => (
                <div
                  className="meter-row"
                  key={`${gx.gridInterconnectDescription.gridInterconnectEntityKey}-meter-container`}
                >
                  <div className="meter-name-container">
                    <div className="meter-name">
                      {gx.gridInterconnectDescription.longGridInterconnectDisplayName
                        ? gx.gridInterconnectDescription.longGridInterconnectDisplayName
                        : 'Utility Meter'}
                    </div>

                    {currentGXData?.gridInterconnects.length > 1 && (
                      <button
                        className="meter-button"
                        onClick={() =>
                          handleMeterSelect(
                            gx.gridInterconnectDescription.gridInterconnectEntityKey
                          )
                        }
                      >
                        View Meter
                      </button>
                    )}
                  </div>

                  <div className={showMobile ? 'meter-container mobile' : 'meter-container'}>
                    {showMobile && (
                      <>
                        <MeterCardContainer
                          currentMeterData={currentSelectedMeterData}
                          gridPower={gx.kiosk.gridkW}
                          solarPower={gx.kiosk.solarkW}
                          batteryPower={gx.kiosk.batterykW}
                          batterySoc={gx.kiosk.batterySoc}
                          batterySockWh={gx.kiosk.batterySockWh}
                          hasSolar={gx.kiosk.hasSolar}
                          hasBattery={gx.kiosk.hasBattery}
                          hasEv={gx.kiosk.hasEvCharger}
                          evPower={gx.kiosk.evChargerkW}
                          hvacPower={gx.kiosk.hvackW}
                          otherPower={gx.kiosk.buildingkW}
                        />
                      </>
                    )}

                    <KioskModel
                      gxPower={gx.kiosk.gridkW}
                      hasSolar={gx.kiosk.hasSolar}
                      solarPower={gx.kiosk.solarkW}
                      hasBattery={gx.kiosk.hasBattery}
                      batteryDisplaySoc={gx.kiosk.batteryDisplaySoc}
                      batterySoc={gx.kiosk.batterySoc}
                      batteryPower={gx.kiosk.batterykW}
                      batterySockWh={gx.kiosk.batterySockWh}
                      hasEv={gx.kiosk.hasEvCharger}
                      hasEvConnected={gx.kiosk.hasEvConnected}
                      evPower={gx.kiosk.evChargerkW}
                      hvacPower={gx.kiosk.hvackW}
                      otherPower={gx.kiosk.buildingkW}
                    />
                  </div>

                  {hasSingleGX && (
                    <EnergyUtilityMeterDetail
                      currentCampusData={currentCampusData}
                      currentCampusId={currentCampusId}
                      currentBuildingId={currentBuildingId}
                      currentZoneId={null}
                      currentGXId={currentGXId}
                      hasSingleGX={hasSingleGX}
                      currentGXData={currentGXData}
                      onBuildingChange={onBuildingChange}
                      onGXChange={onGXChange}
                      onZoneChange={onZoneChange}
                      activePage={activePage}
                      showMobile={showMobile}
                    />
                  )}
                </div>
              ))}
            </>
          ) : (
            <div className="energy-empty-state">
              <EnergyIcon
                backgroundFill={'none'}
                fillColor={'#02222B'}
                strokeColor={'#02222B'}
                strokeWidth={2}
                width="18px"
              />

              <p>There are no grid meters to display.</p>
            </div>
          )}
        </>
      ) : (
        <EnergyUtilityMeterDetail
          currentCampusData={currentCampusData}
          currentCampusId={currentCampusId}
          currentBuildingId={currentBuildingId}
          currentZoneId={null}
          currentGXId={currentGXId}
          hasSingleGX={hasSingleGX}
          currentGXData={currentGXData}
          onBuildingChange={onBuildingChange}
          onGXChange={onGXChange}
          onZoneChange={onZoneChange}
          activePage={activePage}
          showMobile={showMobile}
        />
      )}
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    campuses: state.campuses,
    currentCampusId: state.currentCampusId,
    currentGXId: state.currentGXId,
    currentCampusData: state.currentCampusData,
    currentGXData: state.currentGXData,
  };
};

// used by parent class AuthenticatedComponent
const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentGX: (gxId) => {
      dispatch(setCurrentGX(gxId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Energy));
